import { LatLngExpression } from 'leaflet';
import { primaryPhoneNumber, secondaryPhoneNumber } from '../_constants/brand-contact';
export const CONTACT_DETAILS = [{
  title: 'تلفن',
  value: <div>
                <a href={`tel:${primaryPhoneNumber.value}`}>{primaryPhoneNumber.value}</a> {' - '}
                <a href={`tel:${secondaryPhoneNumber.value}`}>{secondaryPhoneNumber.value}</a>
            </div>
}, {
  title: 'ایمیل پشتیبانی',
  value: <a href='mailto:support@khanoumi.com'>support@khanoumi.com</a>
}, {
  title: 'ایمیل',
  value: <a href='mailto:info@khanoumi.com'>info@khanoumi.com</a>
}, {
  title: 'کد پستی',
  value: <span>1968643134</span>
}, {
  title: 'آدرس',
  value: <span className='mr-2 lg:mr-4'>
                تهران، خیابان ولیعصر، قبل از تقاطع نیایش، نبش خیابان ناصری، ساختمان کیان (پلاک ۲۵۵۱)، طبقه شانزده، دفتر
                مرکزی خانومی
            </span>
}];
export const OFFICE_ADDRESS_LATLNG: LatLngExpression = [35.77008352167609, 51.41189104840844];
export const LINKS = [{
  title: 'پرسش‌های متداول',
  link: '/faq'
}, {
  title: 'حریم خصوصی',
  link: '/privacy'
}];
export const KHANOUMI_HOLIDAYS = [{
  date: '1 فروردین',
  title: 'آغاز نوروز'
}, {
  date: '13 فروردین',
  title: 'روز طبیعت'
}, {
  date: '14 خرداد',
  title: 'رحلت امام خمینی'
}, {
  date: '3 تیر',
  title: 'تاسوعا'
}, {
  date: '4 تیر',
  title: 'عاشورا'
}, {
  date: '13 مرداد',
  title: 'اربعین حسینی'
}, {
  date: '21 مرداد',
  title: 'رحلت رسول اکرم'
}, {
  date: '22 بهمن',
  title: 'پیروزی انقلاب اسلامی'
}];